"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import { EventEmitter } from 'events';
var CHANGE_EVENT = 'change';

var StoreClass =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(StoreClass, _EventEmitter);

  function StoreClass() {
    var _this;

    _classCallCheck(this, StoreClass);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(StoreClass).call(this));

    _this.setMaxListeners(50);

    return _this;
  }

  _createClass(StoreClass, [{
    key: "addChangeListener",
    value: function addChangeListener(cb) {
      this.on(CHANGE_EVENT, cb);
    }
  }, {
    key: "removeChangeListener",
    value: function removeChangeListener(cb) {
      this.removeListener(CHANGE_EVENT, cb);
    }
  }, {
    key: "getList",
    value: function getList() {}
  }]);

  return StoreClass;
}(EventEmitter);

export default StoreClass;